/* Squishy Vault Sofortsuche (Claude 27.10.2026).
   Index: assets/sv-suche-<sprache>.json (tools/squishy_suchindex.py, Begriffe + Synonyme: squishy/daten/suche_woerter.json).
   Tippfehler: Damerau-Levenshtein (eigene kleine Funktion), Wortformen (Plural), Umlaute/Akzente egal, Synonyme in 11 Sprachen,
   Wortteile (Praefix), mehrere Woerter UND-verknuepft (sonst "aehnliche Treffer"). Gewichtung Titel > Art/Tag > Beschreibung,
   Trend-/Lieblings-Bonus. Oberflaeche: ARIA-Combobox im Kopf (Desktop Feld, Handy Lupe -> Blatt), Live-Preis aus /products/<h>.js.
   Suchseite: bei 0 Shopify-Treffern Korrektur ausfuehren (?sv_von=), sonst eigene Treffer zeigen.
   Node-Test: werkzeug/test_suche.js laedt diese Datei (module.exports). */
(function (wurzel) {
  'use strict';

  /* ================= Engine ================= */
  var ERSATZ = [[/ß/g, 'ss'], [/ł/g, 'l'], [/ø/g, 'o'], [/æ/g, 'ae'], [/œ/g, 'oe'], [/đ/g, 'd']];
  function norm(s) {
    s = String(s || '').toLowerCase();
    for (var i = 0; i < ERSATZ.length; i++) s = s.replace(ERSATZ[i][0], ERSATZ[i][1]);
    s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    s = s.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stamm(w) {
    if (w.length <= 4 || /[0-9]/.test(w)) return w;
    if (/ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (/ie$/.test(w)) return w.slice(0, -2) + 'y';
    if (w.length > 5 && /(es|en)$/.test(w)) return w.slice(0, -2);
    if (/[sne]$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function toks(s) { var t = norm(s); return t ? t.split(' ') : []; }
  /* Damerau-Levenshtein (optimal string alignment), bricht ab, sobald max sicher ueberschritten ist */
  function dl(a, b, max) {
    var n = a.length, m = b.length;
    if (Math.abs(n - m) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= n; i++) { d[i] = [i]; }
    for (j = 0; j <= m; j++) d[0][j] = j;
    for (i = 1; i <= n; i++) {
      var zeileMin = Infinity;
      for (j = 1; j <= m; j++) {
        var k = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + k);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
        if (v < zeileMin) zeileMin = v;
      }
      if (zeileMin > max) return max + 1;
    }
    return d[n][m];
  }
  function erlaubt(n) { return n <= 3 ? 0 : n <= 5 ? 1 : 2; }
  function teile(s) { return String(s || '').split(/[^\p{L}\p{N}]+/u).filter(Boolean); }

  function vorbereiten(roh) {
    var I = { roh: roh, stopp: {}, b: roh.b, vok: new Map(), phrasen: [], p: [], c: [], a: [], bDocs: {} };
    (roh.s || []).forEach(function (w) { I.stopp[stamm(norm(w))] = 1; });
    function eintrag(key) {
      var e = I.vok.get(key);
      if (!e) { e = { zeig: '', t: new Set(), x: new Set(), b: [], anz: 0 }; I.vok.set(key, e); }
      return e;
    }
    Object.keys(roh.b).forEach(function (bid) {
      var b = roh.b[bid];
      I.bDocs[bid] = { t: new Set(), k: new Set(), d: new Set() };
      b.w.concat([bid, b.n]).forEach(function (w) {
        var t = toks(w).map(stamm);
        if (!t.length) return;
        var key = t.join('');
        var e = eintrag(key);
        if (e.b.indexOf(bid) < 0) e.b.push(bid);
        if (!e.zeig) e.zeig = b.n;
        if (t.length > 1) I.phrasen.push({ key: key, n: t.length, b: bid });
      });
    });
    roh.p.forEach(function (r, i) {
      var d = { i: i, h: r[0], t: r[1], te: r[2] || '', bild: r[3], pr: r[4], st: r[5], f: r[6], rang: r[11] || 999,
                bt: new Set(r[7]), bk: new Set(r[8]), bd: new Set(r[9]) };
      [[r[1], 't', true], [r[2] || '', 't', false], [r[10] || '', 'x', false]].forEach(function (z) {
        teile(z[0]).forEach(function (teil) {
          toks(teil).forEach(function (tk) {
            var key = stamm(tk), e = eintrag(key);
            e[z[1]].add(i);
            e.anz++;
            if (z[2] && !e.zeig) e.zeig = teil;
          });
        });
      });
      r[7].forEach(function (b) { I.bDocs[b] && I.bDocs[b].t.add(i); });
      r[8].forEach(function (b) { I.bDocs[b] && I.bDocs[b].k.add(i); });
      r[9].forEach(function (b) { I.bDocs[b] && I.bDocs[b].d.add(i); });
      I.p.push(d);
    });
    roh.c.forEach(function (r) { I.c.push({ h: r[0], t: r[1], b: r[2], n: r[3], bild: r[4], w: new Set(toks(r[1]).map(stamm)) }); });
    roh.a.forEach(function (r) { I.a.push({ h: r[0], t: r[1], b: new Set(r[2]), w: new Set(toks(r[1]).map(stamm)) }); });
    I.keys = Array.from(I.vok.keys());
    return I;
  }

  function kandidaten(I, tok) {
    var res = new Map(), exakt = I.vok.has(tok), praefix = false, best = null;
    function setze(k, q) { if (!(res.get(k) >= q)) res.set(k, q); }
    if (exakt) setze(tok, 1);
    if (tok.length >= 2) {
      I.keys.forEach(function (k) {
        if (k.length > tok.length && k.lastIndexOf(tok, 0) === 0) { setze(k, 0.55 + 0.35 * tok.length / k.length); praefix = true; }
      });
    }
    if (!exakt && tok.length >= 4) {
      var max = erlaubt(tok.length);
      I.keys.forEach(function (k) {
        if (Math.abs(k.length - tok.length) <= max) {
          var d = dl(tok, k, max);
          if (d > 0 && d <= max) {
            setze(k, 0.8 - 0.14 * d);
            var e = I.vok.get(k), gewicht = e.anz + e.b.length * 5;
            if (!best || d < best.d || (d === best.d && gewicht > best.g)) best = { k: k, d: d, g: gewicht };
          }
        }
        if (!praefix && k.length > tok.length + 1 && dl(tok, k.slice(0, tok.length), 1) === 1) setze(k, 0.5);
      });
    }
    return { res: res, exakt: exakt, praefix: praefix, best: best };
  }

  function punkte(I, res) {
    /* doc -> beste Punktzahl fuer dieses Suchwort (Titel 3, Art/Tag 2,2, Beschreibung/Farbe 1, Varianten 1,2) */
    var m = new Map();
    function plus(i, v) { if (!(m.get(i) >= v)) m.set(i, v); }
    res.forEach(function (q, k) {
      var e = I.vok.get(k);
      e.t.forEach(function (i) { plus(i, q * 3); });
      e.x.forEach(function (i) { plus(i, q * 1.2); });
      e.b.forEach(function (bid) {
        var bd = I.bDocs[bid];
        if (!bd) return;
        bd.t.forEach(function (i) { plus(i, q * 2.7); });
        bd.k.forEach(function (i) { plus(i, q * 2.2); });
        bd.d.forEach(function (i) { plus(i, q * 1); });
      });
    });
    return m;
  }

  function alleBegriff(I, res) {
    var neutral = res.size > 0;
    res.forEach(function (q, k) {
      if (q < 1) return;
      var e = I.vok.get(k);
      if (!e.b.length || !e.b.every(function (b) { return I.b[b] && I.b[b].a; })) neutral = false;
    });
    return neutral;
  }

  function trendProdukte(I, n) {
    var tr = I.roh.tr || [];
    return I.p.filter(function (d) { return tr.some(function (b) { return d.bt.has(b) || d.bk.has(b); }); })
      .map(function (d) {
        var w = 0;
        tr.forEach(function (b) { if (d.bt.has(b) || d.bk.has(b)) w = Math.max(w, I.b[b].t || 0); });
        return { d: d, s: w * 10 + ((d.f & 2) ? 3 : 0) - d.rang / 100 };
      })
      .sort(function (x, y) { return y.s - x.s; }).slice(0, n || 6).map(function (x) { return x.d; });
  }

  function suche(I, q, opt) {
    opt = opt || {};
    var roh = toks(q);
    var out = { q: q, produkte: [], kategorien: [], ratgeber: [], korrektur: null, uebersetzt: null, teil: false, leer: false, treffer: [] };
    if (!roh.length) { out.leer = true; out.produkte = trendProdukte(I, opt.max || 6); return out; }
    var st = roh.map(stamm);
    /* Suchwoerter (Phrasen zuerst: "slow rising", "huile de coco") */
    var worte = [];
    for (var i = 0; i < st.length;) {
      var genommen = false;
      for (var n = Math.min(3, st.length - i); n >= 2 && !genommen; n--) {
        var key = st.slice(i, i + n).join('');
        var treffer = I.vok.has(key) && I.vok.get(key).b.length ? key : null;
        if (!treffer && key.length >= 8) {
          var grenze = key.length >= 11 ? 2 : 1;
          for (var p = 0; p < I.phrasen.length; p++) {
            if (I.phrasen[p].n === n && dl(key, I.phrasen[p].key, grenze) <= grenze) { treffer = I.phrasen[p].key; break; }
          }
        }
        if (treffer) {
          var r = new Map([[treffer, treffer === key ? 1 : 0.75]]);
          worte.push({ roh: roh.slice(i, i + n).join(' '), res: r, korr: treffer === key ? null : I.vok.get(treffer).zeig, exakt: treffer === key });
          i += n; genommen = true;
        }
      }
      if (genommen) continue;
      var tok = st[i];
      if (I.stopp[tok] && st.length > 1) { i++; continue; }
      var k = kandidaten(I, tok);
      var w = { roh: roh[i], res: k.res, korr: null, exakt: k.exakt || k.praefix };
      if (!k.exakt && !k.praefix && k.best) w.korr = I.vok.get(k.best.k).zeig || k.best.k;
      /* Bekannter Schreibfehler (steht als Wort beim Begriff, z. B. "budder", "kapybara"): trifft exakt, aber "Meintest du"
         zeigt den richtigen Namen, wenn das Wort nah am Anzeigenamen liegt (Synonyme wie "gato" -> "Katze" bleiben stumm) */
      if (k.exakt && !w.korr) {
        var ex = I.vok.get(tok);
        if (!ex.t.size) ex.b.forEach(function (bid) {
          var nn = toks(I.b[bid].n).map(stamm).join(''), g = erlaubt(tok.length);
          if (!w.korr && nn !== tok && g && dl(tok, nn, g) <= g) w.korr = I.b[bid].n;
        });
      }
      worte.push(w);
      i++;
    }
    worte.forEach(function (w) { w.neutral = alleBegriff(I, w.res); w.m = punkte(I, w.res); });
    var pflicht = worte.filter(function (w) { return !w.neutral; });
    if (!pflicht.length && worte.length) pflicht = []; // nur "squishy" o. ae. -> alles, nach Beliebtheit
    var kand;
    if (!pflicht.length) kand = I.p.map(function (d) { return d.i; });
    else {
      kand = Array.from(pflicht[0].m.keys()).filter(function (i) { return pflicht.every(function (w) { return w.m.has(i); }); });
      if (!kand.length && pflicht.length > 1) {
        out.teil = true;
        var u = new Set();
        pflicht.forEach(function (w) { w.m.forEach(function (v, i) { u.add(i); }); });
        kand = Array.from(u);
      }
    }
    var gesuchtSet = worte.some(function (w) { var j = false; w.res.forEach(function (q, k) { if (q >= .7 && I.vok.get(k).b.indexOf('set') > -1) j = true; }); return j; });
    var trendB = I.roh.tr || [];
    var liste = kand.map(function (i) {
      var d = I.p[i], s = 0, anzahl = 0;
      worte.forEach(function (w) { var v = w.m.get(i) || 0; s += w.neutral ? v * 0.1 : v; if (v) anzahl++; });
      if (out.teil) s *= anzahl / worte.length;
      var tw = 0;
      trendB.forEach(function (b) { if (d.bt.has(b) || d.bk.has(b)) tw = Math.max(tw, I.b[b].t || 0); });
      s *= 1 + 0.12 * tw;
      if (d.f & 2) s *= 1.1;
      if (d.f & 4) s *= 1.04;
      if (d.f & 8) s *= 1.05;
      if (d.f & 1) s *= gesuchtSet ? 1.3 : 0.96;
      return { d: d, s: s };
    }).sort(function (x, y) { return y.s - x.s || x.d.rang - y.d.rang || x.d.i - y.d.i; });
    out.treffer = liste;
    out.produkte = liste.slice(0, opt.max || 6).map(function (x) { return x.d; });
    /* Kategorien + Ratgeber */
    function wertung(obj, istKat) {
      var s = 0, alle = true;
      pflicht.forEach(function (w) {
        var best = 0;
        w.res.forEach(function (q, k) {
          if (obj.w.has(k)) best = Math.max(best, q * 2);
          I.vok.get(k).b.forEach(function (b) { if (istKat ? obj.b === b : obj.b.has(b)) best = Math.max(best, q * 3); });
        });
        if (!best) alle = false;
        s += best;
      });
      return alle ? s : s * 0.3;
    }
    if (pflicht.length) {
      out.kategorien = I.c.map(function (c) { return { c: c, s: wertung(c, true) }; }).filter(function (x) { return x.s >= 1.5; })
        .sort(function (x, y) { return y.s - x.s || y.c.n - x.c.n; }).slice(0, 3).map(function (x) { return x.c; });
      out.ratgeber = I.a.map(function (a) { return { a: a, s: wertung(a, false) }; }).filter(function (x) { return x.s >= 1.5; })
        .sort(function (x, y) { return y.s - x.s; }).slice(0, 2).map(function (x) { return x.a; });
    }
    if (!out.produkte.length) { out.leer = true; out.produkte = trendProdukte(I, opt.max || 6); }
    /* "Meintest du" + uebersetzte Suche (fuer die Shopify-Suchseite) */
    if (worte.some(function (w) { return w.korr; })) out.korrektur = worte.map(function (w) { return w.korr || w.roh; }).join(' ');
    out.uebersetzt = worte.map(function (w) {
      if (w.korr) return w.korr;
      var best = null;
      w.res.forEach(function (q, k) { if (q === 1) best = k; });
      var e = best && I.vok.get(best);
      if (e && !e.t.size && e.b.length && !(I.b[e.b[0]] || {}).a) return I.b[e.b[0]].n;
      return w.roh;
    }).join(' ');
    out.worte = worte;
    return out;
  }

  var Engine = { norm: norm, stamm: stamm, dl: dl, vorbereiten: vorbereiten, suche: suche, trendProdukte: trendProdukte };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Engine; return; }
  wurzel.SVSuche = Engine;

  /* ================= Oberflaeche ================= */
  var D = null, I = null, laden = null, preise = new Map(), zahl = 0;
  function daten() {
    if (D) return D;
    var el = document.querySelector('script[data-sv-suche-daten]');
    try { D = el ? JSON.parse(el.textContent) : null; } catch (e) { D = null; }
    return D;
  }
  function indexLaden() {
    if (laden) return laden;
    var d = daten();
    if (!d || !window.fetch) return (laden = Promise.reject(new Error('keine Daten')));
    function hol(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
    laden = hol(d.url).catch(function () { return hol(d.ersatz); }).then(function (roh) { I = vorbereiten(roh); return I; });
    laden.catch(function () { laden = null; });
    return laden;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function txt(k, w) { var t = (daten().t || {})[k] || ''; return w == null ? t : t.replace('%s', w); }
  function url(art, h) { var r = daten().root || ''; if (r === '/') r = ''; return r + '/' + art + '/' + h; }
  function bild(u, b) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + b; }
  function suchUrl(q, von) {
    var d = daten();
    return d.suchen + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last' + (von ? '&sv_von=' + encodeURIComponent(von) : '');
  }
  function markieren(titel, worte) {
    var keys = [];
    (worte || []).forEach(function (w) { w.res.forEach(function (q, k) { if (q >= .5) keys.push(k); }); });
    return teile(titel).length ? titel.replace(/[\p{L}\p{N}]+/gu, function (teil) {
      var k = stamm(norm(teil).replace(/ /g, ''));
      var an = keys.some(function (x) { return x === k || (x.length >= 2 && k.lastIndexOf(x, 0) === 0) || (k.length >= 2 && x.lastIndexOf(k, 0) === 0 && k.length >= 3); });
      return an ? '\u0001' + teil + '\u0002' : teil;
    }).split(/[\u0001\u0002]/).map(function (s, i) { return i % 2 ? '<mark>' + esc(s) + '</mark>' : esc(s); }).join('') : esc(titel);
  }
  function geld(c, cur) {
    try { return new Intl.NumberFormat(daten().intl || undefined, { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function preisHolen(h) {
    if (preise.has(h)) return preise.get(h);
    var p = fetch(url('products', h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function (j) { return { preis: j.price, statt: j.compare_at_price_max > j.price ? j.compare_at_price_max : 0, da: j.available !== false, cur: (window.Shopify && Shopify.currency && Shopify.currency.active) || daten().cur }; });
    p.catch(function () { preise.delete(h); });
    preise.set(h, p);
    return p;
  }
  function preiseZeigen(wurzelEl) {
    wurzelEl.querySelectorAll('[data-sv-preis]').forEach(function (el) {
      var h = el.getAttribute('data-sv-preis');
      preisHolen(h).then(function (p) {
        if (!p.da) { var o = el.closest('[role="option"], .sv-treffer__karte'); if (o) o.classList.add('sv-weg'); return; }
        el.innerHTML = (p.statt ? '<s>' + esc(geld(p.statt, p.cur)) + '</s> ' : '') + '<b>' + esc(geld(p.preis, p.cur)) + '</b>';
        el.classList.add('is-da');
      }).catch(function () { el.classList.add('is-leer'); });
    });
  }
  function merkListe() { try { return JSON.parse(localStorage.getItem('sv_suche_zuletzt') || '[]'); } catch (e) { return []; } }
  function merken(q) {
    q = String(q || '').trim();
    if (q.length < 2) return;
    try {
      var l = merkListe().filter(function (x) { return norm(x) !== norm(q); });
      l.unshift(q);
      localStorage.setItem('sv_suche_zuletzt', JSON.stringify(l.slice(0, 4)));
    } catch (e) {}
  }

  function produktHtml(d, worte) {
    var id = 'svs-o-' + (++zahl);
    var marken = '';
    if (d.f & 1) marken += '<span class="sv-such__marke sv-such__marke--bundle">' + esc(txt('bundle')) + '</span>';
    else if (I.roh.tr.some(function (b) { return d.bt.has(b) || d.bk.has(b); })) marken += '<span class="sv-such__marke">' + esc(txt('trend')) + '</span>';
    return '<a role="option" aria-selected="false" id="' + id + '" class="sv-such__p" href="' + esc(url('products', d.h)) + '">' +
      '<span class="sv-such__bild">' + (d.bild ? '<img src="' + esc(bild(d.bild, 120)) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="sv-such__text"><span class="sv-such__titel">' + markieren(d.t, worte) + '</span>' + (marken ? '<span class="sv-such__marken">' + marken + '</span>' : '') + '</span>' +
      '<span class="sv-such__preis" data-sv-preis="' + esc(d.h) + '"></span></a>';
  }

  function Feld(box) {
    var form = box.querySelector('form'), feld = box.querySelector('input[name="q"]'), panel = box.querySelector('.sv-suche__panel');
    var liste = box.querySelector('[role="listbox"]'), status = box.querySelector('.sv-suche__status');
    var leeren = box.querySelector('.sv-suche__leeren'), lupe = box.querySelector('.sv-suche__lupe-knopf');
    var zu = box.querySelector('.sv-suche__zu');
    var heim = form.parentNode, letztes = null, aktiv = -1, uhr = 0, offen = false;

    function optionen() { return Array.prototype.filter.call(liste.querySelectorAll('[role="option"]'), function (o) { return !o.classList.contains('sv-weg'); }); }
    function markiere(n) {
      var os = optionen();
      os.forEach(function (o) { o.setAttribute('aria-selected', 'false'); o.classList.remove('is-aktiv'); });
      aktiv = n;
      if (n < 0 || !os[n]) { aktiv = -1; feld.removeAttribute('aria-activedescendant'); return; }
      os[n].setAttribute('aria-selected', 'true');
      os[n].classList.add('is-aktiv');
      feld.setAttribute('aria-activedescendant', os[n].id);
      os[n].scrollIntoView({ block: 'nearest' });
    }
    function oeffnen() {
      if (offen) return;
      offen = true;
      panel.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
      box.classList.add('is-offen');
      requestAnimationFrame(function () { panel.classList.add('is-da'); });
    }
    function schliessen() {
      if (!offen) return;
      offen = false;
      panel.classList.remove('is-da');
      feld.setAttribute('aria-expanded', 'false');
      box.classList.remove('is-offen');
      markiere(-1);
      panel.hidden = true;
      if (form.parentNode !== heim) blattZu();
    }
    function gruppe(id, titel, inhalt, klasse) {
      return '<div role="group" class="sv-such__gruppe ' + (klasse || '') + '" aria-labelledby="' + id + '"><div class="sv-such__kopf" id="' + id + '" role="presentation">' + esc(titel) + '</div>' + inhalt + '</div>';
    }
    function zeigen(e) {
      zahl = 0;
      var q = feld.value.trim(), h = '';
      letztes = e;
      if (!q) {
        var z = merkListe();
        if (z.length) h += gruppe('svs-g0', txt('zuletzt'), '<div class="sv-such__chips">' + z.map(function (x) { return '<button type="button" role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__chip" data-q="' + esc(x) + '">' + esc(x) + '</button>'; }).join('') + '</div>');
        h += gruppe('svs-g1', txt('beliebt'), '<div class="sv-such__chips">' + I.roh.tr.map(function (b) { return '<button type="button" role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__chip sv-such__chip--trend" data-q="' + esc(I.b[b].n) + '">' + esc(I.b[b].n) + '</button>'; }).join('') + '</div>');
        h += gruppe('svs-g2', txt('produkte'), e.produkte.map(function (d) { return produktHtml(d, []); }).join(''), 'sv-such__gruppe--p');
      } else {
        if (e.korrektur && norm(e.korrektur) !== norm(q)) h += '<button type="button" role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__meint" data-q="' + esc(e.korrektur) + '">' + esc(txt('meintest')) + ' <b>' + esc(e.korrektur) + '</b>?</button>';
        if (e.leer) h += '<p class="sv-such__leer">' + esc(txt('leer')) + '</p>';
        else if (e.teil) h += '<p class="sv-such__leer">' + esc(txt('teil')) + '</p>';
        if (e.kategorien.length) h += gruppe('svs-g3', txt('kategorien'), '<div class="sv-such__chips">' + e.kategorien.map(function (c) {
          return '<a role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__kat" href="' + esc(url('collections', c.h)) + '">' + (c.bild ? '<img src="' + esc(bild(c.bild, 64)) + '" alt="" width="28" height="28" loading="lazy">' : '') + '<span>' + markieren(c.t, e.worte) + '</span><small>' + c.n + '</small></a>';
        }).join('') + '</div>', 'sv-such__gruppe--k');
        h += gruppe('svs-g4', e.leer ? txt('beliebt') : txt('produkte'), e.produkte.map(function (d) { return produktHtml(d, e.leer ? [] : e.worte); }).join(''), 'sv-such__gruppe--p');
        if (e.ratgeber.length) h += gruppe('svs-g5', txt('ratgeber'), e.ratgeber.map(function (a) {
          return '<a role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__r" href="' + esc(url('blogs/guides', a.h)) + '"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M3 4.5c2.5-1 5-1 7 .8 2-1.8 4.5-1.8 7-.8v11c-2.5-1-5-1-7 .8-2-1.8-4.5-1.8-7-.8z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M10 5.3v11" stroke="currentColor" stroke-width="1.6"/></svg><span>' + markieren(a.t, e.worte) + '</span></a>';
        }).join(''), 'sv-such__gruppe--r');
        h += '<a role="option" aria-selected="false" id="svs-o-' + (++zahl) + '" class="sv-such__alle" href="' + esc(suchUrl(e.korrektur && !e.exaktGefunden ? e.korrektur : q, e.korrektur ? q : '')) + '">' + esc(txt('alle', '„' + q + '“')) + '</a>';
      }
      liste.innerHTML = h;
      status.textContent = txt('n', String(e.produkte.length));
      aktiv = -1;
      feld.removeAttribute('aria-activedescendant');
      preiseZeigen(liste);
      oeffnen();
    }
    function rechnen() {
      indexLaden().then(function (idx) {
        var q = feld.value;
        if (leeren) leeren.hidden = !q;
        var e = suche(idx, q, { max: q.trim() ? 6 : 4 });
        e.exaktGefunden = !e.leer && !e.teil && e.worte && e.worte.every(function (w) { return w.exakt || w.neutral; });
        zeigen(e);
      }).catch(function () {});
    }
    feld.addEventListener('focus', function () { indexLaden(); rechnen(); });
    feld.addEventListener('input', function () { clearTimeout(uhr); uhr = setTimeout(rechnen, 40); });
    box.addEventListener('pointerenter', function () { indexLaden(); }, { once: true });
    feld.addEventListener('keydown', function (ev) {
      var os = optionen();
      if (ev.key === 'ArrowDown') { ev.preventDefault(); if (!offen) rechnen(); else markiere(aktiv + 1 >= os.length ? 0 : aktiv + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); if (offen) markiere(aktiv <= 0 ? os.length - 1 : aktiv - 1); }
      else if (ev.key === 'Enter' && aktiv > -1 && os[aktiv]) { ev.preventDefault(); os[aktiv].click(); }
      else if (ev.key === 'Escape') {
        if (offen) { ev.preventDefault(); schliessen(); if (form.parentNode !== heim) blattZu(); }
        else if (feld.value) { feld.value = ''; if (leeren) leeren.hidden = true; }
      }
    });
    liste.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-q]');
      if (b) { ev.preventDefault(); feld.value = b.getAttribute('data-q'); feld.focus(); rechnen(); return; }
      var a = ev.target.closest('a[href]');
      if (a) merken(feld.value);
    });
    liste.addEventListener('mousedown', function (ev) { if (ev.target.closest('button')) ev.preventDefault(); }); // Fokus bleibt im Feld
    form.addEventListener('submit', function (ev) {
      var q = feld.value.trim();
      if (!q) { ev.preventDefault(); feld.focus(); return; }
      merken(q);
      if (letztes && letztes.korrektur && !letztes.exaktGefunden && norm(letztes.korrektur) !== norm(q)) {
        ev.preventDefault();
        location.href = suchUrl(letztes.korrektur, q);
      }
    });
    if (leeren) leeren.addEventListener('click', function () { feld.value = ''; leeren.hidden = true; feld.focus(); rechnen(); });
    document.addEventListener('pointerdown', function (ev) {
      if (!offen) return;
      if (!form.contains(ev.target) && !(lupe && lupe.contains(ev.target))) schliessen();
    });
    form.addEventListener('focusout', function (ev) {
      if (form.parentNode !== heim) return;
      if (ev.relatedTarget && !form.contains(ev.relatedTarget)) schliessen();
    });

    /* Handy/Schublade: Lupe oeffnet ein Blatt ueber der Seite (Formular wandert solange an body, sonst greift contain:layout des Kopfs) */
    var blatt = null;
    function blattAuf() {
      if (!blatt) { blatt = document.createElement('div'); blatt.className = 'sv-suche-blatt'; blatt.setAttribute('role', 'dialog'); blatt.setAttribute('aria-modal', 'true'); blatt.setAttribute('aria-label', txt('oeffnen')); }
      document.body.appendChild(blatt);
      blatt.appendChild(form);
      document.documentElement.classList.add('sv-suche-gesperrt');
      requestAnimationFrame(function () { blatt.classList.add('is-da'); });
      feld.focus();
      rechnen();
    }
    function blattZu() {
      if (!blatt) return;
      heim.appendChild(form);
      blatt.classList.remove('is-da');
      blatt.remove();
      document.documentElement.classList.remove('sv-suche-gesperrt');
      if (lupe) lupe.focus({ preventScroll: true });
      if (offen) schliessen();
    }
    if (lupe) lupe.addEventListener('click', function () { indexLaden(); blattAuf(); });
    if (zu) zu.addEventListener('click', function () { schliessen(); blattZu(); });
  }

  /* Suchseite: Hinweis bei Korrektur, bei 0 Treffern korrigieren oder eigene Treffer zeigen */
  function seite() {
    var s = document.querySelector('[data-sv-suche-seite]');
    if (!s) return;
    var q = s.getAttribute('data-q') || '', n = parseInt(s.getAttribute('data-n') || '0', 10);
    var par = new URLSearchParams(location.search), von = par.get('sv_von'), aus = par.get('sv_aus');
    if (von) {
      s.innerHTML = '<p class="sv-treffer__hinweis">' + esc(txt('statt', '„' + q + '“')) + ' <a href="' + esc(daten().suchen + '?q=' + encodeURIComponent(von) + '&sv_aus=1') + '">' + esc(txt('statt_orig', '„' + von + '“')) + '</a></p>';
    }
    if (!q.trim() || n > 0) return;
    indexLaden().then(function (idx) {
      var e = suche(idx, q, { max: 24 });
      var ziel = e.korrektur || e.uebersetzt;
      if (!von && !aus && !e.leer && ziel && norm(ziel) !== norm(q)) { location.replace(suchUrl(ziel, q)); return; }
      var titel = e.leer ? txt('beliebt') : txt('tresor', '„' + q + '“');
      var karten = e.produkte.map(function (d) {
        return '<a class="sv-treffer__karte" href="' + esc(url('products', d.h)) + '"><span class="sv-treffer__bild"><img src="' + esc(bild(d.bild, 360)) + '" alt="" loading="lazy" width="180" height="180"></span>' +
          '<span class="sv-treffer__titel">' + esc(d.t) + '</span><span class="sv-treffer__preis" data-sv-preis="' + esc(d.h) + '"></span>' +
          ((d.f & 1) ? '<span class="sv-such__marke sv-such__marke--bundle">' + esc(txt('bundle')) + '</span>' : '') + '</a>';
      }).join('');
      var box = document.createElement('section');
      box.className = 'sv-treffer';
      box.innerHTML = '<h2 class="sv-h2">' + esc(titel) + '</h2>' + (e.leer ? '<p class="sv-treffer__hinweis">' + esc(txt('leer')) + '</p>' : '') + '<div class="sv-treffer__raster">' + karten + '</div>';
      s.appendChild(box);
      preiseZeigen(box);
    }).catch(function () {});
  }

  function start() {
    if (!daten()) return;
    document.querySelectorAll('[data-sv-suche]').forEach(function (b) { if (!b.svFeld) { b.svFeld = 1; Feld(b); } });
    seite();
  }
  if (document.prerendering) document.addEventListener('prerenderingchange', start, { once: true });
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
